import { API } from "services/api";
import type {
  CompareShipmentRequest,
  CompareShipmentResponse,
  GetPedidosResponse,
} from "./realizarCotacao.types";

export const getPedidos = async (): Promise<GetPedidosResponse> => {
  const { data } = await API.get<GetPedidosResponse>("/pedidos");
  return data;
};

export const postCompareShipment = async (
  payload: CompareShipmentRequest,
): Promise<CompareShipmentResponse> => {
  const response = await API.post<CompareShipmentResponse>(
    "/api/shipments/compare",
    payload,
  );

  return response.data;
};
